const scope = "misc";
export default scope;
